/* import __COLOCATED_TEMPLATE__ from './sq-input-hexrgb.hbs.js'; */
import { computed } from '@ember/object';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import Component from '@ember/component';
import tinycolor from 'tinycolor2';

/**
## hex rgb input
`sq-input-hexrgb` renders an input element designed to accept colors. It accepts
anything that tinycolor will take as an argument to its constructor including:

* hex values e.g. `#15abcd`, `f0f`, `#ff00`
* named colors e.g. `blue`, `fuchsia`, `blanchedalmond`
* hsl/hsv/rgb e.g. `hsl(40, 15%, 80%)`, `rgb(255, 0, 32)`

It only fires an onchange event if the user enters a valid color.

Also it positions a square inside the input element that represents the inputted
color. If the input is invalid, it renders a box with a dashed border

```example
@title Basic Example

@hbs
{{sq-input-hexrgb value=color onchange=(action (mut color))}}

@controller-properties
{
  color: "red"
}
```

### Parameters
@param {string} [value] The color that should be
@param {action} [onchange] This action is sent when the user enters a valid color
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['sq-input-hexrgb'],
  didReceiveAttrs() {
    this._super();
    if (this.value) {
      // only update the value in the text field if the current value doesn't
      // match the supplied value so that it doesn't update while the user is
      // editing
      const newColor = tinycolor(this.value);
      const currentColor = tinycolor(this._value);
      if (newColor.toHexString() !== currentColor.toHexString()) {
        this.set('_value', newColor.toHexString().toUpperCase());
      }
    }
  },
  hexValue: computed('_value', function () {
    return tinycolor(this._value).toHexString();
  }),
  isValueValid: computed('_value', function () {
    return tinycolor(this._value).isValid();
  }),
  actions: {
    inputChanged(event) {
      const newValue = event.target.value;
      const color = tinycolor(newValue);
      if (color.isValid() && this.onchange) {
        this.onchange(color.toHex());
      }
    },
    inputFocusedOut(event) {
      const newValue = event.target.value;
      const color = tinycolor(newValue);
      if (color.isValid()) {
        this.set('_value', color.toHexString().toUpperCase());
      }
    }
  }
});